import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Grid } from '@chakra-ui/react';
import { Checkbox } from '../../inputs';
import { JsFieldName, JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
/**
 * Component renders "/schemas/jsf-checkbox" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is boolean.
 */
const CheckboxJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['boolean'], children: _jsxs(Grid, { "data-testid": "CheckboxJsField-test", "data-name": props.name, gridTemplateColumns: "minmax(0, 180px) 1fr", alignItems: "center", gap: "4px", children: [_jsx(JsFieldName, { name: props.schema.title }), _jsx(Checkbox, { checked: Boolean(props.formData), onChange: props.onChange })] }) }));
};
export const CheckboxJsField = CheckboxJsFieldFC;
//# sourceMappingURL=CheckboxJsField.js.map